<template>
  <b-navbar fixed-top spaced shadow class="is-white">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img
          src="@/assets/logo_minedu.png"
          alt="Placeholder logo"
        >
      </b-navbar-item>

      <b-navbar-item>
        <strong> {{ $t('components.navigationBar.brandingText') }} </strong>
      </b-navbar-item>
    </template>

    <template slot="end">
      <b-navbar-dropdown>
        <div slot="label">
          <b-icon icon="earth"></b-icon>
          <span>
            {{ $t('components.navigationBar.localeChanger.language') }}
          </span>
        </div>
        <b-navbar-item
          v-for="(locale, i) in locales"
          :key="i"
          class="has-text-justified"
          @click="changeLocale(locale.code)"
        >
          <img :src="locale.flag" :alt="locale.code">
          <span>
            {{ locale.name }}
          </span>
        </b-navbar-item>
      </b-navbar-dropdown>

      <b-navbar-item v-if="$keycloak.authenticated">
        <span v-if="getLocale() === 'el'">
          {{ getGreekName(getToken()) }}
        </span>
        <span v-else>
          {{ getLatinName(getToken()) }}
        </span>
      </b-navbar-item>

      <b-navbar-item tag="div" v-if="$keycloak.authenticated">
        <div class="buttons">
          <b-button
            tag="button"
            type="is-light"
            icon-right="logout"
            @click="logout"
          >
          </b-button>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { tokenUtils } from '@/mixins/tokenUtils'

export default {
  name: 'NavigationBar',
  mixins: [tokenUtils],
  data () {
    return {
      locales: (this.$i18n.availableLocales).map(item => ({
        code: item,
        flag: require('@/assets/' + item + '.svg'),
        name: this.$i18n.messages[item].common.locale.nativeName
      }))
    }
  },
  methods: {
    ...mapActions([
      'logout',
      'setLocale'
    ]),
    ...mapGetters([
      'getLocale',
      'getToken'
    ]),
    changeLocale (code) {
      this.$i18n.locale = code

      this.setLocale(code)
    }
  }
}
</script>
